import { Component, OnInit } from '@angular/core';
import { AppVersionModel } from 'src/app/models/app-config';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {

  constructor(private service: UtilsService) { }

  public version: AppVersionModel;
  ngOnInit(): void {

    this.getVersion();
  }

  getVersion() {
   this.version =  this.service.getAppVersion();
  }

}
